<script>
import IconCross from './icons/IconCross.vue'

function isObject(variable) {
    if (typeof variable === 'object' && variable !== null) {
        return true
    } else {
        return false
    }
}

export default {
    name: 'BaseTaglist',

    components: { IconCross },

    props: {
        values: {
            type: Array,
        },

        prefix: {
            type: String,
            default: ''
        },

        tagClassname: {
            type: String,
            default: ''
        },

        tagsClassname: {
            type: String,
            default: ''
        },

        trackBy: {
            type: String,
            default: 'value'
        },

        tagValue: {
            type: [String, Function],
            default: 'value'
        }
    },

    data() {
        return {
            uid: undefined,
            isTouchDevice: undefined,
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'checkbox' + Math.random()
            this.isTouchDevice = 'ontouchstart' in document.documentElement
        }
    },

    methods: {
        handleRemoveClick(tag) {
            this.$emit('change', tag)
        },

        getTagKey(tag) {
            if (isObject(tag)) {
                return tag[this.trackBy]
            }

            return tag
        },

        getTagValue(tag) {
            if (isObject(tag)) {
                if (typeof this.tagValue === "string") {
                    return tag[this.tagValue]
                } else {
                    return this.tagValue(tag)
                }
            }

            return tag
        }
    }
}
</script>

<template>
    <div class="base-taglist" :class="{ 'not-touch-device': !isTouchDevice }">
        <div class="before">
            <slot name="before" />
        </div>
        <div >
            <span v-html="prefix"></span> <div :class="`tags ${tagsClassname}`">
                <div :class="`tag ${tagClassname}`" v-for="tag in values" :key="getTagKey(tag)">
                    {{ getTagValue(tag) }}
                    <div class="remove" @click="handleRemoveClick(tag)" @keydown.enter="handleRemoveClick(tag)" tabindex="0">
                        <IconCross style="width:10px" />
                    </div>
                </div>
            </div>
        </div>
        <div class="after">
            <slot name="after" />
        </div>
    </div>
</template>

<style lang="stylus">
@import '../assets/stylus/vars.styl'

.base-taglist
    font-size 16px
    .before:empty
    .after:empty
        display none

    .tags
        display inline-flex

    .tag
        display inline-flex
        padding 5px
        margin-right 5px
        font-weight 600
        align-items center

        .remove
            cursor pointer
            display inline-block
            margin-left 7px
            font-weight normal
            font-size 18px
            color var(--AkGreyscaleDarkGrey)

            &:focus-visible
                outline 2px solid black

</style>
